import { useContext, useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { UseAuth } from "../../../utils/UseAuth";
import Breadcrumbs from "../../../components/auth/breadcrumbs/Breadcrumbs";
import { CONSTANT } from "../../../constant/Constant";
import { TokenContext } from "../../../context/TokenContext";
import { GALLERY } from "../../../api/Gallery";

export default function GalleryUpdate() {
  const { token } = useContext(TokenContext);
  const [loading, setLoading] = useState(false);
  const { checkAccessTokenValidity } = UseAuth();

  const [reRunData, setReRunData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [imageView, setimageView] = useState("");
  const [imageView2, setimageView2] = useState("");
  const [imageView3, setimageView3] = useState("");
  const [imageView4, setimageView4] = useState("");
  const [imageView5, setimageView5] = useState("");
  const [imageView6, setimageView6] = useState("");
  const [data, setData] = useState({
    txt1: "",
    desp1: "",
    galImg1: null,

    txt2: "",
    desp2: "",
    galImg2: null,

    txt3: "",
    desp3: "",
    galImg3: null,

    txt4: "",
    desp4: "",
    galImg4: null,

    txt5: "",
    desp5: "",
    galImg5: null,

    txt6: "",
    desp6: "",
    galImg6: null,
  });
  const validationSchema = Yup.object().shape({
    txt1: Yup.string().required("* Required"),
    desp1: Yup.string().required("* Required"),
    galImg1: Yup.mixed()
      .required("Thumbnail is required")
      .test("fileType", "Unsupported file format", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return ["image/jpeg", "image/png", "image/jpg"].includes(value.type);
      })
      .test("fileSize", "File size is too large", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return value.size <= 5 * 1024 * 1024; // 5MB limit
      }),
    txt2: Yup.string().required("* Required"),
    desp2: Yup.string().required("* Required"),
    galImg2: Yup.mixed()
      .required("Thumbnail is required")
      .test("fileType", "Unsupported file format", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return ["image/jpeg", "image/png", "image/jpg"].includes(value.type);
      })
      .test("fileSize", "File size is too large", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return value.size <= 5 * 1024 * 1024; // 5MB limit
      }),
    txt3: Yup.string().required("* Required"),
    desp3: Yup.string().required("* Required"),
    galImg3: Yup.mixed()
      .required("Thumbnail is required")
      .test("fileType", "Unsupported file format", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return ["image/jpeg", "image/png", "image/jpg"].includes(value.type);
      })
      .test("fileSize", "File size is too large", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return value.size <= 5 * 1024 * 1024; // 5MB limit
      }),
    txt4: Yup.string().required("* Required"),
    desp4: Yup.string().required("* Required"),
    galImg4: Yup.mixed()
      .required("Thumbnail is required")
      .test("fileType", "Unsupported file format", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return ["image/jpeg", "image/png", "image/jpg"].includes(value.type);
      })
      .test("fileSize", "File size is too large", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return value.size <= 5 * 1024 * 1024; // 5MB limit
      }),
    txt5: Yup.string().required("* Required"),
    desp5: Yup.string().required("* Required"),
    galImg5: Yup.mixed()
      .required("Thumbnail is required")
      .test("fileType", "Unsupported file format", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return ["image/jpeg", "image/png", "image/jpg"].includes(value.type);
      })
      .test("fileSize", "File size is too large", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return value.size <= 5 * 1024 * 1024; // 5MB limit
      }),
    txt6: Yup.string().required("* Required"),
    desp6: Yup.string().required("* Required"),
    galImg6: Yup.mixed()
      .required("Thumbnail is required")
      .test("fileType", "Unsupported file format", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return ["image/jpeg", "image/png", "image/jpg"].includes(value.type);
      })
      .test("fileSize", "File size is too large", (value) => {
        if (typeof value === "string") return true;
        if (!value) return false;
        return value.size <= 5 * 1024 * 1024; // 5MB limit
      }),
  });
  const handleSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("txt1", values.txt1);
    formData.append("desp1", values.desp1);
    formData.append("galImg1", values.galImg1);

    formData.append("txt2", values.txt2);
    formData.append("desp2", values.desp2);
    formData.append("galImg2", values.galImg2);

    formData.append("txt3", values.txt3);
    formData.append("desp3", values.desp3);
    formData.append("galImg3", values.galImg3);

    formData.append("txt4", values.txt4);
    formData.append("desp4", values.desp4);
    formData.append("galImg4", values.galImg4);

    formData.append("txt5", values.txt5);
    formData.append("desp5", values.desp5);
    formData.append("galImg5", values.galImg5);

    formData.append("txt6", values.txt6);
    formData.append("desp6", values.desp6);
    formData.append("galImg6", values.galImg6);

    formData.append("isPurged", false);
    try {
      setLoading(false);
        // const res = await GALLERY.ADD(formData, token);
      const res = await GALLERY.UPDATE(formData, data._id, token);
      if (res.status === 200) {
        toast.success("Updated Gallery");
      } else {
        toast.error("Failed to Update Gallery");
        throw new Error("failed to create an topic");
      }
    } catch (error) {
      setLoading(false);
      if (error.response.status === 401) {
        await checkAccessTokenValidity();
        setReRunData(values);
        setRefresh(!refresh);
      }
      // console.log("error", error);
    }
  };
  const handleImageChange = (file, setFieldValue) => {
    setData({
      ...data,
      galImg1: file,
    });
    const fileLoaded = URL.createObjectURL(file);
    setimageView(fileLoaded);
    setFieldValue("galImg1", file);
  };
  const handleImageChange2 = (file, setFieldValue) => {
    setData({
      ...data,
      galImg2: file,
    });
    const fileLoaded = URL.createObjectURL(file);
    setimageView2(fileLoaded);
    setFieldValue("galImg2", file);
  };
  const handleImageChange3 = (file, setFieldValue) => {
    setData({
      ...data,
      galImg3: file,
    });
    const fileLoaded = URL.createObjectURL(file);
    setimageView3(fileLoaded);
    setFieldValue("galImg3", file);
  };
  const handleImageChange4 = (file, setFieldValue) => {
    setData({
      ...data,
      galImg4: file,
    });
    const fileLoaded = URL.createObjectURL(file);
    setimageView4(fileLoaded);
    setFieldValue("galImg4", file);
  };
  const handleImageChange5 = (file, setFieldValue) => {
    setData({
      ...data,
      galImg5: file,
    });
    const fileLoaded = URL.createObjectURL(file);
    setimageView5(fileLoaded);
    setFieldValue("galImg5", file);
  };
  const handleImageChange6 = (file, setFieldValue) => {
    setData({
      ...data,
      galImg6: file,
    });
    const fileLoaded = URL.createObjectURL(file);
    setimageView6(fileLoaded);
    setFieldValue("galImg6", file);
  };

  const getGalleryData = async () => {
    try {
      const res = await GALLERY.GET_ALL();
      const galData = res.data[0];
      if (res.status !== 200) {
        throw new Error("Failed to fetch brand information");
      }
      setData(galData);
      setimageView(`${CONSTANT.UI_URL}gallery/${galData.galImg1}`);
      setimageView2(`${CONSTANT.UI_URL}gallery/${galData.galImg2}`);
      setimageView3(`${CONSTANT.UI_URL}gallery/${galData.galImg3}`);
      setimageView4(`${CONSTANT.UI_URL}gallery/${galData.galImg4}`);
      setimageView5(`${CONSTANT.UI_URL}gallery/${galData.galImg5}`);
      setimageView6(`${CONSTANT.UI_URL}gallery/${galData.galImg6}`);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };
  useEffect(() => {
    if (reRunData !== null) handleSubmit(reRunData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);
  useEffect(() => {
    getGalleryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Breadcrumbs pageName="Update Gallery" />
      <div className=" rounded-md border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark">
          <h3 className="font-medium text-black dark:text-white">
            Gallery Info
          </h3>
        </div>
        <Formik
          initialValues={data}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {(formik) => (
            <Form>
              <div className="grid grid-cols-1 sm:grid-cols-2 pt-6.5">
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Heading 1<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="txt1"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="txt1"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Sub Heading 1<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="desp1"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="desp1"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Image 1<span className="text-meta-1">*</span>
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label
                      htmlFor="image-file1"
                      className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                    >
                      {imageView !== "" ? (
                        <div className="w-full group relative cursor-pointer h-full flex justify-center items-center rounded ">
                          <img
                            src={imageView}
                            alt="images"
                            className="h-full object-contain"
                          />
                          <button
                            type="button"
                            className="transition transform w-full h-full
                                                             translate-y-8 ease-in-out invisible  
                                                             absolute group-hover:visible 
                                                                 text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75 "
                            onClick={() => {
                              setData({
                                ...data,
                                svcImg1: "",
                              });
                              setimageView("");
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload Image
                              </span>
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              PNG, JPG or JPEG (MAX. 800x400px)
                            </p>
                          </div>
                          <input
                            id="image-file1"
                            type="file"
                            className="hidden "
                            onChange={(e) => {
                              handleImageChange(
                                e.target.files[0],
                                formik.setFieldValue
                              );
                            }}
                          />
                        </>
                      )}
                    </label>
                  </div>
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="svcImg1"
                  />
                </div>
                <div className="p-6.5 pt-0" />

                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Heading 2<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="txt2"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="txt2"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Sub Heading 2<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="desp2"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="desp2"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Image 2<span className="text-meta-1">*</span>
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label
                      htmlFor="image-file2"
                      className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                    >
                      {imageView2 !== "" ? (
                        <div className="w-full group relative cursor-pointer h-full flex justify-center items-center rounded ">
                          <img
                            src={imageView2}
                            alt="images"
                            className="h-full object-contain"
                          />
                          <button
                            type="button"
                            className="transition transform w-full h-full
                                                             translate-y-8 ease-in-out invisible  
                                                             absolute group-hover:visible 
                                                                 text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75 "
                            onClick={() => {
                              setData({
                                ...data,
                                svcImg2: "",
                              });
                              setimageView2("");
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload Image
                              </span>
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              PNG, JPG or JPEG (MAX. 800x400px)
                            </p>
                          </div>
                          <input
                            id="image-file2"
                            type="file"
                            className="hidden "
                            onChange={(e) => {
                              handleImageChange2(
                                e.target.files[0],
                                formik.setFieldValue
                              );
                            }}
                          />
                        </>
                      )}
                    </label>
                  </div>
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="svcImg2"
                  />
                </div>
                <div className="p-6.5 pt-0" />

                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Heading 3<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="txt3"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="txt3"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Sub Heading 3<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="desp3"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="desp3"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Image 3<span className="text-meta-1">*</span>
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label
                      htmlFor="image-file3"
                      className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                    >
                      {imageView3 !== "" ? (
                        <div className="w-full group relative cursor-pointer h-full flex justify-center items-center rounded ">
                          <img
                            src={imageView3}
                            alt="images"
                            className="h-full object-contain"
                          />
                          <button
                            type="button"
                            className="transition transform w-full h-full
                                                             translate-y-8 ease-in-out invisible  
                                                             absolute group-hover:visible 
                                                                 text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75 "
                            onClick={() => {
                              setData({
                                ...data,
                                svcImg3: "",
                              });
                              setimageView3("");
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload Image
                              </span>
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              PNG, JPG or JPEG (MAX. 800x400px)
                            </p>
                          </div>
                          <input
                            id="image-file3"
                            type="file"
                            className="hidden "
                            onChange={(e) => {
                              handleImageChange3(
                                e.target.files[0],
                                formik.setFieldValue
                              );
                            }}
                          />
                        </>
                      )}
                    </label>
                  </div>
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="svcImg3"
                  />
                </div>
                <div className="p-6.5 pt-0" />

                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Heading 4<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="txt4"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="txt4"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Sub Heading 4<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="desp4"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="desp4"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Image 4<span className="text-meta-1">*</span>
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label
                      htmlFor="image-file4"
                      className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                    >
                      {imageView4 !== "" ? (
                        <div className="w-full group relative cursor-pointer h-full flex justify-center items-center rounded ">
                          <img
                            src={imageView4}
                            alt="images"
                            className="h-full object-contain"
                          />
                          <button
                            type="button"
                            className="transition transform w-full h-full
                                                             translate-y-8 ease-in-out invisible  
                                                             absolute group-hover:visible 
                                                                 text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75 "
                            onClick={() => {
                              setData({
                                ...data,
                                svcImg4: "",
                              });
                              setimageView4("");
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload Image
                              </span>
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              PNG, JPG or JPEG (MAX. 800x400px)
                            </p>
                          </div>
                          <input
                            id="image-file4"
                            type="file"
                            className="hidden "
                            onChange={(e) => {
                              handleImageChange4(
                                e.target.files[0],
                                formik.setFieldValue
                              );
                            }}
                          />
                        </>
                      )}
                    </label>
                  </div>
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="svcImg4"
                  />
                </div>
                <div className="p-6.5 pt-0" />

                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Heading 5<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="txt5"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="txt5"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Sub Heading 5<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="desp5"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="desp5"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Image 5<span className="text-meta-1">*</span>
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label
                      htmlFor="image-file5"
                      className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                    >
                      {imageView5 !== "" ? (
                        <div className="w-full group relative cursor-pointer h-full flex justify-center items-center rounded ">
                          <img
                            src={imageView5}
                            alt="images"
                            className="h-full object-contain"
                          />
                          <button
                            type="button"
                            className="transition transform w-full h-full
                                                             translate-y-8 ease-in-out invisible  
                                                             absolute group-hover:visible 
                                                                 text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75 "
                            onClick={() => {
                              setData({
                                ...data,
                                svcImg5: "",
                              });
                              setimageView5("");
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload Image
                              </span>
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              PNG, JPG or JPEG (MAX. 800x400px)
                            </p>
                          </div>
                          <input
                            id="image-file5"
                            type="file"
                            className="hidden "
                            onChange={(e) => {
                              handleImageChange5(
                                e.target.files[0],
                                formik.setFieldValue
                              );
                            }}
                          />
                        </>
                      )}
                    </label>
                  </div>
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="svcImg5"
                  />
                </div>
                <div className="p-6.5 pt-0" />

                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Heading 6<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="txt6"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="txt6"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Sub Heading 6<span className="text-meta-1">*</span>
                  </label>
                  <Field
                    name="desp6"
                    placeholder="Add sub heading"
                    rows={6}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />
                  <ErrorMessage
                    name="desp6"
                    component="a"
                    className="text-danger"
                  />
                </div>
                <div className="p-6.5 pt-0">
                  <label className="mb-2.5 block text-black dark:text-white">
                    Image 6<span className="text-meta-1">*</span>
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label
                      htmlFor="image-file6"
                      className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-50 hover:bg-gray dark:border-gray dark:hover:border-gray dark:hover:bg-gray"
                    >
                      {imageView6 !== "" ? (
                        <div className="w-full group relative cursor-pointer h-full flex justify-center items-center rounded ">
                          <img
                            src={imageView6}
                            alt="images"
                            className="h-full object-contain"
                          />
                          <button
                            type="button"
                            className="transition transform w-full h-full
                                                             translate-y-8 ease-in-out invisible  
                                                             absolute group-hover:visible 
                                                                 text-white group-hover:translate-y-0 bg-black flex justify-center items-center opacity-75 "
                            onClick={() => {
                              setData({
                                ...data,
                                svcImg6: "",
                              });
                              setimageView6("");
                            }}
                          >
                            <svg
                              className="fill-current"
                              width="30"
                              height="30"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                                fill=""
                              />
                              <path
                                d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                                fill=""
                              />
                              <path
                                d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                                fill=""
                              />
                              <path
                                d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                                fill=""
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg
                              className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 16"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                              <span className="font-semibold">
                                Click to upload Image
                              </span>
                            </p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                              PNG, JPG or JPEG (MAX. 800x400px)
                            </p>
                          </div>
                          <input
                            id="image-file6"
                            type="file"
                            className="hidden "
                            onChange={(e) => {
                              handleImageChange6(
                                e.target.files[0],
                                formik.setFieldValue
                              );
                            }}
                          />
                        </>
                      )}
                    </label>
                  </div>
                  <ErrorMessage
                    component="a"
                    className="text-danger"
                    name="svcImg6"
                  />
                </div>
                <div className="p-6.5 pt-0" />
              </div>

              <div className="p-6.5 pt-0">
                <button
                  type="submit"
                  className="flex w-full justify-center rounded bg-primary p-3 font-medium text-gray"
                >
                  {loading ? (
                    <div className="flex h-auto items-center justify-center ">
                      <div className="h-6 w-6 animate-spin rounded-full border-4 border-solid border-white border-t-transparent"></div>
                    </div>
                  ) : (
                    "Update Gallery"
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
